<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-row dense>
                <v-col cols="12">
                    <v-chip
                            v-if="reply.field.datetime.type === 'date'"
                            class="mr-2">
                        <v-icon left>
                            mdi-calendar-check
                        </v-icon>
                        {{ reply.field_datetime.value }}
                    </v-chip>
                    <v-chip
                            v-if="reply.field.datetime.type === 'time'"
                            class="mr-2">
                        <v-icon left>
                            mdi-alarm-check
                        </v-icon>
                        {{ reply.field_datetime.value }}
                    </v-chip>
                </v-col>
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldDatetimeReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
    }
</script>

<style scoped>

</style>